import React, {useEffect, useState} from 'react';
import {ThemeProvider} from '@mui/material';
import {theme} from '../../theme';
import Button from '@mui/material/Button';
import {setSessionTime} from '../../utils/sessionTime';
import Paper from '@mui/material/Paper';

import styles from './Login.module.css';
import Logo from './Logo';
import brandingService from '../../services/BrandingService';

export default function Login() {
    const [, setAppName] = useState(brandingService.getAppName());
    const [showLogo, setShowLogo] = useState(brandingService.shouldShowLogo());

    useEffect(() => {
        brandingService.init().then(() => {
            setAppName(brandingService.getAppName());
            setShowLogo(brandingService.shouldShowLogo());
            document.title = brandingService.getDocumentTitle();
        });
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <div className={styles.page}>
                <Paper sx={{background: 'white', padding: '24px', borderRadius: '16px'}}>

                    {showLogo && (
                        <div style={{ paddingBottom: '24px' }}>
                            <Logo/>
                        </div>
                    )}
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            sx={{
                                width: '200px',
                                background: 'linear-gradient(129.04deg, #FDAB2F 8.28%, rgba(255, 98, 154, 0.94) 51.96%, #7C0DEB 99.16%)',
                                color: 'white',
                            }}
                            onClick={() => {
                                setSessionTime();
                                window.location.reload();
                            }}
                        >
                            {brandingService.getLoginButtonLabel()}
                        </Button>
                    </div>
                </Paper>
            </div>
        </ThemeProvider>
    );
}
